import React from 'react';
import { ChevronLeft, ChevronRight, CheckCircle } from 'lucide-react';

function WorkflowFooter({ currentStep, totalSteps, onPrevious, onNext, onSubmit, canSubmit, isEditMode }) {
  return (
    <div className="bg-gray-50 px-6 py-4 border-t border-gray-200 flex justify-between items-center" data-wizard-footer>
      <button
        onClick={onPrevious}
        disabled={currentStep === 1}
        data-wizard-action="previous"
        className={`px-6 py-2 rounded-lg flex items-center gap-2 ${
          currentStep === 1
            ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
            : 'bg-gray-300 text-gray-700 hover:bg-gray-400'
        }`}
      >
        <ChevronLeft className="w-5 h-5" />
        Precedent
      </button>

      <div className="text-sm text-gray-600">
        Etape {currentStep} sur {totalSteps}
      </div>

      {currentStep < totalSteps ? (
        <button
          onClick={onNext}
          data-wizard-action="next"
          className="px-6 py-2 bg-amber-500 text-white rounded-lg hover:bg-amber-600 flex items-center gap-2"
        >
          Suivant
          <ChevronRight className="w-5 h-5" />
        </button>
      ) : (
        <button
          onClick={onSubmit}
          disabled={!canSubmit}
          data-wizard-action="submit"
          className={`px-6 py-2 rounded-lg flex items-center gap-2 ${
            !canSubmit
              ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
              : 'bg-green-600 text-white hover:bg-green-700'
          }`}
        >
          <CheckCircle className="w-5 h-5" />
          {isEditMode ? 'Enregistrer les Modifications' : 'Enregistrer le Vehicule'}
        </button>
      )}
    </div>
  );
}

export default WorkflowFooter;
